"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IGS_NURTURING = exports.MARKETING_SALES = void 0;
var MARKETING_SALES = 'marketing-sales';
exports.MARKETING_SALES = MARKETING_SALES;
var IGS_NURTURING = 'igs-nurturing';
exports.IGS_NURTURING = IGS_NURTURING;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/constants/RepTypes.js
// module id = 453
// module chunks = 5 6